import { EntityListTypeName } from '@ydistri/api-sdk';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuEntityListSpecification } from './SkuEntityListSpecification';

export class ForcedEntityListSpecification extends SkuEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.FORCEDLISTS,
      'Forced list administration',
      'Forced list',
      'Forced lists',
      'FRC',
      [EntityListTypeName.Source, EntityListTypeName.Target],
    );
  }
}
